import { combineReducers } from "redux";

import { connectRouter } from "connected-react-router";
import auth from "./auth";
import user from "./user";
import articles from "./articles";
import freelancer from "./freelancer";
import business from "./business";
import forum from "./forum";
import catadvs from "./catadvs";
import yellowpage from "./yellowpage";
import video from "./video";
import log from "./log";
import sub from "./sub";

export default history =>
  combineReducers({
    router: connectRouter(history),
    auth,
    user,
    articles,
    freelancer,
    business,
    forum,
    catadvs,
    yellowpage,
    video,
    log,
    sub
  });
